export default "__VITE_ASSET__BkKkCWXE__"